import SeoMetaData from "common/SeoMetaData"
import {
  StaticPropsFactory,
  StaticPropsFactoryProps,
} from "common/StaticPropsFactory"
import PrivacyPolicyMarkdown from "docs/privacy-policy.mdx"

export const getStaticProps = StaticPropsFactory("privacyPolicy")

export default function PrivacyPolicy({ seo }: StaticPropsFactoryProps) {
  return (
    <>
      <SeoMetaData data={seo} />
      <PrivacyPolicyMarkdown />
    </>
  )
}
